import { Typography } from '@legacy/components/mui-components';
import { useGetCurrentPageTitle } from '@legacy/stores/PageStore/pageStore.zustand';

export const HeaderTitle = () => {
  const pageTitle = useGetCurrentPageTitle();

  return (
    <Typography
      data-automation-id="ScreenHeaderTitle"
      component="h1"
      variant="h3"
      fontWeight={500}
    >
      {pageTitle}
    </Typography>
  );
};
